import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResourceCountriesRepository } from '@/core/domain/resource-countries/repositories/resource-countries.repository';
import { GetResourceCountriesUseCase } from '../../core/domain/resource-countries/usecases/getResourceCountries.usecase';
import { ResourceCountriesImplRepository } from './resource-countries.impl.repository';

const GetResourceCountriesUseCaseFactory = (
    resourceCountriesRepository: ResourceCountriesRepository,
) => new GetResourceCountriesUseCase(resourceCountriesRepository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: GetResourceCountriesUseCase,
            useFactory: GetResourceCountriesUseCaseFactory,
            deps: [ResourceCountriesRepository],
        },
        {
            provide: ResourceCountriesRepository,
            useClass: ResourceCountriesImplRepository,
        },
    ],
})
export class ResourceCountriesDataModule {}
